import React from 'react'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

const variant = {
  primary: 'text-white bg-secondary enabled:hover:bg-secondary-200',
  secondary: 'text-primary-400 border border-primary-400',
}

export default function Button(props) {
  return (
    <button
      {...props}
      className={twMerge(
        clsx(
          'px-20 py-14 w-full text-left rounded-5 flex justify-center items-center disabled:opacity-50',
          variant[props.variant],
          props.className,
        ),
      )}
    />
  )
}
